import React from 'react'
import { graphql } from 'gatsby'
import { ContentfulComponentFooter } from 'types/contentful'
import RichText from './rich-text'
import * as styles from './footer.module.css'

type FooterProps = {
  footer: ContentfulComponentFooter
}

const Footer = ({ footer }: FooterProps) => {
  return (
    <footer
      className={styles.footer}
      style={{
        backgroundColor: `${footer?.backgroundColorHex}`,
        color: `${footer?.textColorHex}`,
      }}
    >
      <div className="container">
        {footer?.copy && (
          <div className={styles.copy}>
            <RichText data={footer.copy} />
          </div>
        )}
        <div className={styles.footerFlex}>
          {footer?.logo && (
            <div className={styles.logo}>
              <a
                href={footer?.logoUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className={styles.logoImage}
                  src={footer?.logo.image.file.url}
                  alt={footer?.logo.image.title}
                />
              </a>
            </div>
          )}
          <div className="links-copyright">
            <ul className={styles.links}>
              {(footer?.links || []).map((link) => (
                <li key={link.contentful_id}>
                  <a className={styles.links} href={link.url}>
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
            <p className={styles.copyright}>{footer?.copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer

export const query = graphql`
  fragment FooterFields on ContentfulComponentFooter {
    backgroundColorHex
    textColorHex
    copy {
      raw
    }
    logo {
      image {
        title
        file {
          url
        }
      }
    }
    logoUrl
    links {
      contentful_id
      text
      url
    }
    copyright
  }
`
